/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import Colcade from 'colcade';

export function init() {
  const newsGrids = document.querySelectorAll('[data-news-grid]');
  newsGrids.forEach(newsGrid => {
    new Colcade(newsGrid, {
      columns: '[data-news-grid-col]',
      items: '[data-news-grid-item]',
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/news-grid.js